import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { tableAnatomy } from "@chakra-ui/anatomy";

const helpers = createMultiStyleConfigHelpers(tableAnatomy.keys);

/**
 * Table variant `premium` (DEFAULT; `simple` is aliased to it so untouched pages upgrade too):
 * sunken head, uppercase `label` th in text.muted, hairline dividers, last row borderless, navy.50 row hover,
 * `isNumeric` cells right-aligned with tabular figures. Rows with `data-clickable="true"` get a pointer cursor.
 * Wrap in <DataTable> (src/components/ui) for the bordered container + scroll fade. Use size="sm" for nested tables.
 */
const premium = {
  table: { borderCollapse: "separate", borderSpacing: 0, fontVariantNumeric: "tabular-nums lining-nums" },
  thead: { bg: "surface.sunken" },
  th: {
    fontFamily: "body",
    fontSize: "0.75rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "text.muted",
    borderBottom: "1px solid",
    borderColor: "border.strong",
    whiteSpace: "nowrap",
    "&[data-is-numeric=true]": { textAlign: "end" },
  },
  td: {
    fontWeight: 500,
    color: "text.primary",
    borderBottom: "1px solid",
    borderColor: "border.default",
    verticalAlign: "middle",
    "&[data-is-numeric=true]": { textAlign: "end", fontWeight: 600 },
  },
  tbody: {
    tr: {
      transition: "background-color 120ms",
      _hover: { bg: "navy.50" },
      "&[data-clickable=true]": { cursor: "pointer" },
      _last: { td: { borderBottom: "none" } },
    },
  },
  tfoot: { tr: { th: { borderTop: "1px solid", borderColor: "border.strong" } } },
  caption: { color: "text.muted", fontSize: "0.75rem", fontWeight: 600 },
};

export const Table = helpers.defineMultiStyleConfig({
  variants: { premium, simple: premium },
  sizes: {
    sm: {
      th: { py: 2.5, px: 3, lineHeight: 1.2 },
      td: { py: 2.5, px: 3, fontSize: "0.8125rem", lineHeight: 1.4 },
      caption: { px: 3, py: 2 },
    },
    md: {
      th: { py: 3, px: 4, lineHeight: 1.2 },
      td: { py: 3.5, px: 4, fontSize: "0.875rem", lineHeight: 1.45 },
      caption: { px: 4, py: 2 },
    },
  },
  defaultProps: { variant: "premium", size: "md" },
});
